module.exports = __webpack_public_path__ + "img/app2.0021f5ed.png";